import React from "react";
import { AvatarGroup, Avatar, Tooltip, Box } from "@mui/material";
import Avatar_ from "./Avatar_";

const CustomAvatarGroup = ({ data }) => {
  const visibleCount = 4; // Number of avatars to display
  const totalCount = data?.applicants?.length || 0;
  const remainingCount = totalCount - visibleCount;

  return (
    <Box display="flex" alignItems="center">
      <AvatarGroup max={visibleCount} sx={{ display: "flex" }}>
        {data?.applicants?.slice(0, visibleCount).map((applicant, index) => (
          <Tooltip title={applicant?.name} key={index}>
            <Avatar_
              name={applicant?.name}
              photo={applicant.photo}
              key={index}
            />
            {/* <Avatar src={applicant.photo} alt={applicant.name}>
              {applicant.name?.[0]}
            </Avatar> */}
          </Tooltip>
        ))}
      </AvatarGroup>
      {remainingCount > 0 && (
        <Avatar
          sx={{
            fontSize: "0.875rem",
            bgcolor: "primary.main",
            color: "white",
            ml: -1.5, // Overlap adjustment
            zIndex: 1,
          }}
        >
          {remainingCount > 999
            ? `${Math.floor(remainingCount / 1000)}k+`
            : `+${remainingCount}`}
        </Avatar>
      )}
    </Box>
  );
};

export default CustomAvatarGroup;
